/**
 * 작업 상세를 **연 목록이 이미 보이고 있는 칸**들.
 *
 * eric 2026-09-23 「오른쪽에 보면 선택된 부분과 겹치는 내용 보이지? … 이건 row 에 보이는 거니
 * 상세에선 다 빼.」
 *
 * 🔴 **작업 상세는 서랍이 두 곳에서 열린다** — 작업 목록과 이력이고, **두 목록의 열이 다르다.**
 *    그래서 「무엇이 겹치는가」는 상세가 알 수 없다. 연 쪽이 말해 주는 것이 맞다.
 * 🔴 **전체 페이지(장비 관점 콘솔 · 태블릿)에서는 아무것도 안 넘긴다** — 거기엔 목록이 옆에
 *    없어서 전부 보여야 한다. 넘기지 않으면 한 줄도 안 빠진다.
 * ⚠ 이 상수는 **목록 화면의 `columns` 와 짝이다.** 열을 더하거나 빼면 여기도 같이 고쳐라 —
 *   안 고치면 상세에 값이 두 번 뜨거나(더할 때) 아예 안 보인다(뺄 때).
 */
/* ⚠ 「시료 수」(`sampleCount`)는 2026-10-22 에 「작업」 카드에서 뺐다(eric) — 그 수는 「시료」 카드 표의 건수가 말한다 */
export type BatchListedField = 'created' | 'started' | 'duration' | 'owner'

/*
 * 🔴 **2026-09-28 부터 둘 다 비었다** — eric 「목록의 일부 열을 공간이 모자라면 숨겨야지」. 서랍이 열려 목록이
 *    좁아지면 시료 수 · 생성 · 시작 · 소요 시간이 **목록에서 빠진다**(`listColumnPriority.ts`). 빠진 값이 갈 곳은
 *    이 서랍뿐이라 「목록에 보이니 서랍에서 뺀다」가 더는 성립하지 않는다(실측: 1255~1790 전 폭에서 서랍을 열면
 *    이 열들이 목록에서 빠진다). 규칙은 「목록에서 숨을 수 있는 열은 서랍에 있다」로 바뀌었다(`drawerNoRepeat.test.tsx`).
 * ⚠ 틀(`listedFields`)은 남긴다 — 목록 열 중 «끝까지 남는» 것이 이 다섯 칸 중에 생기면 여기 적으면 된다.
 * ⚠ 「작업자」(`owner`)는 2026-09-30 오전에 뺐다가 같은 날 **admin 전용으로 되살렸다**(`batchOwnerColumn.tsx`) —
 *   목록 열 · 서랍 「작업」 카드 줄 둘 다 admin 에게만 선다. 목록에서 숨을 수 있는 열이라 여기엔 안 적는다.
 */

/**
 * `BatchesScreen` 의 열 — 작업 ID · 상태 · 시료 수 · 레시피 · (작업자 · admin 만) · 생성 · 시작 · 종료(2026-09-30 · 이력에서 소요 시간만 뺀 차례).
 * 작업 ID · 상태 말고는 전부 숨을 수 있어 비워 둔다 — 서랍 카드들이 같은 값을 다 적는다(시료 수 = 「시료」 표 건수 · 레시피 = 「레시피」 카드).
 */
export const BATCHES_LIST_FIELDS: readonly BatchListedField[] = []

/**
 * `HistoryScreen` 의 열 — 작업 ID · 상태(종전 「결과」) · 시료 수 · 레시피 · (작업자 · admin 만) · 생성 · 시작 · 종료 · 소요 시간(2026-09-30).
 * 작업 ID · 상태 말고는 전부 숨을 수 있어 비워 둔다 — 서랍 「작업」 카드가 생성 · 작업 시작 · 작업 종료(= 목록의 「종료」) · 소요 시간을 다 적는다.
 */
export const HISTORY_LIST_FIELDS: readonly BatchListedField[] = []
